<div class="advanced-filter-delete-dialog">
  <div class="advanced-filter-delete-dialog__close">
    <button [mat-dialog-close]>
      <img src="../../../assets/icons/cancel.svg" />
    </button>
  </div>

  <div class="advanced-filter-delete-dialog__text">You're deleting the filter</div>
  <div class="advanced-filter-delete-dialog__name">'{{ data.name }}'</div>
  <div class="advanced-filter-delete-dialog__title">This can't be undone. <br /></div>

  <div class="advanced-filter-delete-dialog__button">
    <button class="global_hover_button" (click)="deleteAdvancedFilter()">Delete filter</button>
  </div>
</div>
